<div class="row">
  <div class="col-md-4 col-lg-3 col-12 side-menu-container">
    <app-side-menu
      [subscription_id]="subscription_id"
      (showResponse)="displayResponse($event)"
      (clearRes)="clearResponse($event)"
      [response]="response"
    ></app-side-menu>
  </div>
  <div class="col-md-8 col-lg-9 col-12">
    <div class="chat-container">
      <div id="chat-area" *ngIf="showChatArea">
        <div id="chats" *ngIf="showDefault">
          <div class="chat-placeholder" *ngIf="!waitingMessage">
            <img
              src="./assets/img/asset-logo.svg"
              alt="Logo"
              class="mx-auto img-fluid d-block mb-3"
            />
            <b class="default-text">
              {{ "asset_output.default_heading" }}
            </b>
            <p class="default-text">
              {{ "asset_output.sub_heading" }}
            </p>
          </div>
        </div>
        <ng-container *ngIf="waitingMessage">
          <div class="spinner-container">
            <div class="spinner mx-auto"></div>
            <p>{{ "asset_output.spinner" }}</p>
          </div>
        </ng-container>
        <ng-container *appDynamicLoader="appMeta"></ng-container>
      </div>
      <div
        class="row pt-2 border-top justify-content-center"
        *ngIf="showChatArea && !showDefault"
      >
        <div class="col-md-8 col-12 px-4 column-disclaimer">
          <span class="footer-disclaimer"
            >This AI-generated content is not completely error-free or
            up-to-date. While we strive for accuracy and quality, we recommend
            independently verifying the content. We do not assume any
            responsibility or liability for the use or interpretation of this
            content.</span
          >
        </div>
      </div>
    </div>
  </div>
</div>

<div id="chat-icon" (click)="sendEmail()">
  <img
    src="./assets/img/support.svg"
    alt="Logo"
    title="Your feedback is important to us"
  />
</div>
